import { render } from "./VSelectJQ.vue?vue&type=template&id=4025e016"
import script from "./VSelectJQ.vue?vue&type=script&lang=js"
export * from "./VSelectJQ.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__